"use strict";


export class FileDecorator {

    constructor (langCode, selector) {
        var trans;
        if(langCode != 'cs'){
            trans = {
                vybran_soubor: 'Selected file'
            }
        }else{
            trans = {
                vybran_soubor: 'Vybrán soubor'
            }
        }
        FileDecorator.trans = trans;
        this.selector = selector??'input[type=file]';

    }

    static bytesToSize (bytes) { 
        var sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return '0 B';
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    }

    static change(event) {
        let target=event.target.closest?.('input[type=file]');
        let parent=target?.closest?.('.vut-file');
        if (!parent) return;
        // nutno zpozdit, jinak to pak kopírovač kopíruje i s hodnotama ... //
        setTimeout(()=> {
            if (target.files.length) {
                let name = Array.from(target.files).map((file) => file.name).join(', ');
                parent.querySelectorAll('.vut-file-btn-add .vut-file-btn-text').forEach((e) => e.innerHTML = e.closest('.vut-file-btn-add').dataset.labelchange);
                parent.querySelectorAll('.vut-file-label').forEach((e) => e.innerHTML = FileDecorator.trans.vybran_soubor + ': ' + name);
                if (!parent.querySelector('.vut-file-btn-remove')) {
                    parent.querySelectorAll('.vut-file-btn-add').forEach((e) => e.insertAdjacentHTML('afterend', '<span class="vut-file-btn-remove btn btn-icon-only btn-default"><span class="icon-cross2 red"></span></span>'));
                }
            } else {
                parent.querySelectorAll('.vut-file-btn-add .vut-file-btn-text').forEach((e) => e.innerHTML = e.closest('.vut-file-btn-add').dataset.labeladd);
                parent.querySelectorAll('.vut-file-label').forEach((e) => e.innerHTML = e.dataset.origlabel);
                parent.querySelectorAll('.vut-file-btn-remove').forEach((e)=>e.remove());
            }
        }, 50);
    }

    static remove(event) {
        let target = event.target.closest?.('.vut-file-btn-remove');
        let parent=target?.closest?.('.vut-file');
        let input=parent?.querySelector('input[type=file]');
        if (!(parent&&input)) return;
        // nutno zpozdit, jinak to pak kopírovač nezahazuje ... //
        setTimeout(()=> {
            input.value = null;
            input.insertAdjacentHTML('beforeBegin', input.outerHTML);
            input.remove();
            parent.querySelectorAll('.vut-file-btn-add .vut-file-btn-text').forEach((e) => e.innerHTML = e.closest('.vut-file-btn-add').dataset.labeladd);
            parent.querySelectorAll('.vut-file-label').forEach((e) => e.innerHTML = e.dataset.origlabel);
            parent.querySelectorAll('.vut-file-btn-remove').forEach((e) => e.remove());
        }, 50);
    }

    init () {
        window.addEventListener('change', FileDecorator.change, true);
        window.addEventListener('click', FileDecorator.remove, true);
    }

};